import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OpsOrderCreatorsQueryVariables = Types.Exact<{
  system?: Types.InputMaybe<Types.OpsOrderSystem>;
}>;


export type OpsOrderCreatorsQuery = { __typename?: 'Query', opsOrderCreators: Array<{ __typename?: 'IdName', id: string, name: string }> };


export const OpsOrderCreatorsDocument = gql`
    query OpsOrderCreators($system: OpsOrderSystem) {
  opsOrderCreators(system: $system) {
    id
    name
  }
}
    `;

/**
 * __useOpsOrderCreatorsQuery__
 *
 * To run a query within a React component, call `useOpsOrderCreatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpsOrderCreatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpsOrderCreatorsQuery({
 *   variables: {
 *      system: // value for 'system'
 *   },
 * });
 */
export function useOpsOrderCreatorsQuery(baseOptions?: Apollo.QueryHookOptions<OpsOrderCreatorsQuery, OpsOrderCreatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpsOrderCreatorsQuery, OpsOrderCreatorsQueryVariables>(OpsOrderCreatorsDocument, options);
      }
export function useOpsOrderCreatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpsOrderCreatorsQuery, OpsOrderCreatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpsOrderCreatorsQuery, OpsOrderCreatorsQueryVariables>(OpsOrderCreatorsDocument, options);
        }
export type OpsOrderCreatorsQueryHookResult = ReturnType<typeof useOpsOrderCreatorsQuery>;
export type OpsOrderCreatorsLazyQueryHookResult = ReturnType<typeof useOpsOrderCreatorsLazyQuery>;
export type OpsOrderCreatorsQueryResult = Apollo.QueryResult<OpsOrderCreatorsQuery, OpsOrderCreatorsQueryVariables>;